export default __webpack_public_path__ + "static/musical-theater-7e3a995e13e8e3cfcf0a3580a87bd6ff.jpg";